// extracted by css-extract-rspack-plugin
export default {"root":"ZDd2UX","content":"PrRJZD","reason":"O6qDPg","error-message":"PHMMbM","errorMessage":"PHMMbM"};